exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Mixins\n */\n#data {\n  max-width: 1024px;\n  margin: 0 auto;\n  padding: 30px 0; }\n  #data i {\n    font-size: 13px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/data/data.component.scss
// module id = ../../../../../src-admin/app/components/data/data.component.scss
// module chunks = main